import React from 'react'

function ErrorPage (props) {
  return (
    <p data-testid='error-page'>
      <strong>Error:</strong> {props.message}
    </p>
  )
}

export default ErrorPage
